import { donationBillingsField as fields, getClassNameForField } from '../../constants'
import { useTranslationService } from '../../util/TranslationContext'
import { EditableFormPage } from '../components/EditableFormPage'
import { useParams } from 'react-router-dom'

const DonatorsSlug = () => {
    const { id } = useParams()
    const { translateFields } = useTranslationService()
    const donationBillingsField = translateFields(fields, 'donation_billings')

    return (
        <>
            <EditableFormPage
                fetchUrl={`admin/donation-billings/${id}`}
                fields={donationBillingsField}
                classNameForField={getClassNameForField}
                errorMessage='Failed to fetch data.'
                readOnly={true}
            />
        </>
    )
}

export default DonatorsSlug
